import { Popover as AntdPopover, Popover } from "antd"

const PopOver = props => {
  return <AntdPopover {...props}>{props.children}</AntdPopover>
}
export default PopOver
